import React from 'react';
import type {
  AnomalyNotePayload,
  AnomalyRevisionHistoryPayload,
  MLResultPair,
} from '../../../../Insights/types';

// Times in Unix seconds (matches chart DateTimeNumericAxis)
export type AnomalyBand = {
  id: string;
  startTime: number;
  endTime: number;
};

export type AnomalyBandType = 'anomaly' | 'anchor';

export type AnomalyBandWithForm = AnomalyBand & {
  bandType?: AnomalyBandType;
  persistedId?: string;
  anomalyId?: string;
  notes?: AnomalyNotePayload[];
  pendingNotes?: AnomalyNotePayload[];
  revisionHistory?: AnomalyRevisionHistoryPayload[];
  streams?: string[];
  criticality?: string;
  indicators?: string[];
  rootCauses?: string[];
  actions?: string[];
  mlResults?: MLResultPair[];
  confidence?: number;
  savings?: number;
  userNotes?: string;
  /** Open-ended anomaly: backend endDate is the ongoing sentinel (year 9999). */
  ongoing?: boolean;
  createdByUserId?: string;
  createdByUserName?: string;
};

/** Default form values for new anomalies - used when adding to local state before save. Required fields (streams, criticality) start empty so bands appear red until filled. */
export const DEFAULT_ANOMALY_FORM_VALUES: Omit<AnomalyBandWithForm, 'id' | 'startTime' | 'endTime'> = {
  persistedId: undefined,
  anomalyId: undefined,
  notes: [],
  pendingNotes: [],
  revisionHistory: [],
  streams: [],
  criticality: undefined,
  indicators: [],
  rootCauses: [],
  actions: [],
  mlResults: undefined,
  confidence: undefined,
  savings: undefined,
  userNotes: '',
  ongoing: true,
  createdByUserId: undefined,
  createdByUserName: undefined,
};

export type AnomalyBandsConfig = {
  bands: AnomalyBandWithForm[];
  setBands: React.Dispatch<React.SetStateAction<AnomalyBandWithForm[]>>;
  selectedBandId: string | null;
  setSelectedBandId: (id: string | null) => void;
  keepSingleBandSelected?: boolean;
  readOnly?: boolean;
  pendingDeleteBandId: string | null;
  setPendingDeleteBandId: (id: string | null) => void;
  registerUpdater: (updater: (bands: AnomalyBandWithForm[], selectedBandId: string | null) => void) => () => void;
};
